import React from 'react';
import I18N from '@leverege/i18n';
import { IconUtil } from '@leverege/ui-elements';
import FilterSourceModel from "./FilterSourceModel.js";
import FilterSourcesModel from "./FilterSourcesModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.filters.ClearAllAction');
export default {
  id: 'molten.filters.ClearFiltersAction',
  matches: {
    use: 'sortFilterBar',
    client: 'GroupScreen'
  },
  layout: {
    sort: 'b.a'
  },
  handles: context => {
    const {
      filters,
      filterName = 'filterBar'
    } = context;
    const filter = FilterSourcesModel.getSource(filters, filterName);
    return filter?.sort != null || filter?.filter != null;
  },
  appearance: ({
    context,
    action
  }) => {
    const icon = tIcon('clearFiltersIcon', 'fa fa-fw fa-close');
    return {
      name: /*#__PURE__*/_jsxs(React.Fragment, {
        children: [IconUtil.create(icon), /*#__PURE__*/_jsx("span", {
          children: t('label')
        })]
      })
    };
  },
  perform: ({
    context
  }) => {
    const {
      filterName = 'filterBar',
      onFilterChange
    } = context;
    const fsm = FilterSourceModel.create();
    onFilterChange({
      value: fsm,
      data: filterName
    });
  }
};